import { useNavigate } from "react-router-dom";

export const useAuth = () => {
  const navigate = useNavigate();

  const userDetails = JSON.parse(localStorage.getItem("userDetails") || "{}");
  const permissions = userDetails?.userdata?.permissions
    ? JSON.parse(userDetails.userdata.permissions)
    : [];

  const isAdmin = userDetails?.userdata?.is_admin === 1;

  const hasPermission = (permission) => {
    return isAdmin || permissions.includes(permission);
  };

  const onLogout = () => {
    localStorage.removeItem("userDetails");
    navigate("/");
  };

  return {
    userDetails,
    isAdmin,
    permissions,
    hasPermission,
    onLogout,
  };
};
